import { createStore, combineReducers } from 'redux'
import projectStateReducer, { xesProjectInitialState } from './project-state'
import projectTitleReducer, { projectTitleInitialState } from './project-title'
import baizeReducer, { baizeInitialState } from './baize'

const scratchGui = combineReducers({
  xesProjectState: projectStateReducer,
  projectTitle: projectTitleReducer,
  baizeState: baizeReducer
})
const reducer = combineReducers({
  scratchGui
})
const initialState = {
  scratchGui: {
    xesProjectState: xesProjectInitialState,
    projectTitle: projectTitleInitialState,
    baizeState: baizeInitialState
  }
}
const store = createStore(reducer, initialState)
window.dbgstore = store
export default store